import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ComponentDefinition } from '@formbird/types';
import type { BroadcastService } from 'formbird-services';
import { ChangedDocumentService } from 'formbird-services';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormbirdInjectorService } from '../../../../formbird-services/src/lib/services/injector/formbird-injector.service';
import { SclCsvParserService } from '../../../../formbird-sc-shared/src/lib/scl-csv-parser.service';
import { SclCsvParserHandlerService } from '../../../../formbird-sc-shared/src/lib/scl-csv-parser-handler.service';
import { SclUtilImporterService } from '../../../../formbird-sc-shared/src/lib/scl-util-importer.service';
import * as cloneDeep from 'lodash/cloneDeep';
import * as $ from 'jquery';
import * as moment from 'moment';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { UtilSharingNgService } from '../../../../formbird-sc-shared/src/lib/util-sharing-ng.service';
import { Observable } from 'rxjs';
import { ClientRulesService } from '../../../../formbird-services/src/lib/services/rules/client-rules.service';
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormField } from '@angular/material/form-field';

const logger = console;
declare var Papa;

interface ImportFileComponentDefinition extends ComponentDefinition {
  caption?: string;
  onClick?: string;
  style?: string;
  openIn?: any;
  columns?: any;
  extraColumns?: any;
  extraColumnsValue?: any;
  labels?: any;
  templateId?: any;
  dataServiceBatchCount?: any;
  dataServiceBatchDelay?: any;
  documentIdMatch?: any;
  documentIdNoMatch?: any;
  directImporting?: any;
  targetTable?: any;
  disableSaving?: any;
  csvFieldNamePrefix?: any;
  hideStatusCounts?: boolean;
}

@Component({
  templateUrl: './import-file.component.html',
  styleUrls: ['./import-file.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportFileComponent extends AbstractComponent<ImportFileComponentDefinition> implements OnInit {

  @Input() floatLabel: any;
  isHasTargetTableComponent: boolean;
  functionListToBeCalledInPublic: any;
  disableSaving: any;
  imported: number;
  recordsRead: number;
  documentCreated: number;
  errors: number;
  items: any = [];
  itemsMatTableData: any = [];

  templateId: any;
  columns: any;
  extraColumns: any;
  extraColumnsValue: any;
  labels: any;
  docIdMatch: any;
  docIdNoMatch: any;
  tempDocId?: any;
  documentIdIndexInColumn?: any;

  accept = '.json, .csv';
  files: File[] = [];
  progress: number;
  hasBaseDropZoneOver = false;
  dragFiles: any;
  lastInvalids: any;
  fileDropDisabled = false;
  maxSize: any;
  baseDropValid: any;

  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource([]);
  // dataSource: any;
  @ViewChild('importFilePaginator') paginator: MatPaginator;
  @ViewChild('table', {static: true}) table;

  notificationService: any;
  dataService: any;
  labelsForNoTargetTable: any;
  cloneDeepFunction: any;

  protected broadcastService: BroadcastService;
  private batchCount: any;
  private dataServiceBatchCount: any;
  private dataServiceBatchDelay: any;
  batchLimit: number;
  batchLimitCounter: any;
  holderObjToInsert: any;
  holderObjRecord: any;
  private incompleteSaving: any;

  constructor(
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef,
    protected formbirdInjectorService: FormbirdInjectorService,
    private sclCsvParser: SclCsvParserService,
    private sclCsvParserHandler: SclCsvParserHandlerService,
    private sclUtilImporter: SclUtilImporterService,
    private utilSharingNgService: UtilSharingNgService,
    private clientRulesService: ClientRulesService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
    this.notificationService = this.formbirdInjectorService.get('NotificationService');
    this.dataService = this.formbirdInjectorService.get('DataService');
    this.cloneDeepFunction = cloneDeep;
  }

  funcCallSaveImports(){
    if(!this.incompleteSaving){
      this.incompleteSaving= true;
      setTimeout(() => {
        this.saveImports();
      });
    }else{
      console.log('Do not trigger saveImport if saving is in progress');
      this.notificationService.warning('saveImports() cannot be executed because batch saving is ongoing!!');
    }

  }

  saveImports() {
    const self = this;
    if (self.disabled) {
      return;
    }
    if (self.itemsMatTableData && self.itemsMatTableData.length !== 0) {
      if (self.templateId) {
        self.dataService.documentExists(self.templateId).then(
          (found) => {
            if (found) {
              self.dataService.getDocument(self.templateId).then(
                async function success(record) {
                  if (record) {
                    self.imported = 0;
                    self.documentCreated = 0;
                    self.errors = 0;
                    self.tempDocId = null;

                    self.notificationService.info('Saving CSV Imports!');

                    const toInsert = [];
                    self.batchCount = 0;
                    toInsert.push.apply(toInsert, self.itemsMatTableData);
                    self.batchLimit = toInsert.length/self.dataServiceBatchCount;
                    self.batchLimitCounter = 0;
                    const batchLimitStrArr = (self.batchLimit+'').split('.');
                    if(batchLimitStrArr.length>1){
                      self.batchLimit = Number(batchLimitStrArr[0])+1;
                    }else{
                      self.batchLimit = Number(batchLimitStrArr[0]);
                    }
                    self.holderObjToInsert = toInsert;
                    self.holderObjRecord = record;

                    await self.funcRunByBatch(self.batchLimitCounter);

                    self.valueChanged(self.items);
                    self.document[self.fieldName] = self.items;
                    self.detectChanges();
                    // self.notificationService.success(self.imported + ' CSV Imports saved!');
                    // self.dataSource = new MatTableDataSource(self.items);
                    self.loadItemsToDataTable(self.itemsMatTableData);

                    // self.table.renderRows();
                  }
                }, function error() {

                  self.notificationService.error('Document with templateId: ' + self.templateId + ' not found!');
                  self.incompleteSaving= false;
                });
            }
          }, () => {
            self.notificationService.error('Document with templateId: ' + self.templateId + ' is not found!');
            self.incompleteSaving= false;
          });

      } else {
        self.notificationService.error('No templateId specified!');
        self.incompleteSaving= false;
      }
    } else {
      self.notificationService.error('Please upload a csv file!');
      self.incompleteSaving= false;
    }

  }

  async funcRunByBatch(batchNo){
    const self = this;
      const batchStart = batchNo * self.dataServiceBatchCount;
      const batchEnd = batchStart + self.dataServiceBatchCount;
      const batch = self.holderObjToInsert.slice(batchStart, batchEnd);

      console.log('Running batch ' + (batchNo+1), batch, batchStart, batchEnd);
      for (let idx = 0; idx < batch.length; idx++) {
        await self.funcSaveToInsertIndex(
          idx + 1 + batchStart,
          idx + batchStart,
          self.holderObjToInsert,
          self.holderObjRecord
        );
      }
  }
  async funcSaveToInsertIndex(idx,csvIndex,toInsert,record){
    const self = this;

    // if (self.batchCount === self.dataServiceBatchCount) {
    //   self.sleepFor(self.dataServiceBatchDelay);
    //   self.batchCount = 0;
    // }
    const data = toInsert[idx - 1];

    let document = {
      documentId: undefined,
      systemHeader: {
        systemType: 'document',
        templateId: self.templateId
      }
    };

    const dataKeys = Object.keys(data);
    // console.log('dataKeys values log', dataKeys, dataKeys.length);
    for (let j = 2; j < dataKeys.length; j++) {

      let value = data[dataKeys[j]];

      // handle date format
      const componentName = self.columns[j - 2].toString().trim();
      // tslint:disable-next-line:prefer-for-of
      for (let comp = 0; comp < record.components.length; comp++) {
        if (record.components[comp].name === componentName) {
          if (record.components[comp].componentName === 'sc-date-time') {
            const dateValue = moment(value.trim(), 'DD/MM/YYYY hh:mm A');
            if (dateValue.isValid()) {
              value = dateValue;
            }
            break;
          }
        }
      }

      // convert string value to array value using ^ delimiter
      const delimiterValue = value.toString().trim().split('^');
      if (delimiterValue && (delimiterValue.length > 1)) {
        value = delimiterValue;
      }

      // convert string true|false value to a boolean value
      value = (value === 'true') ? true : value;
      value = (value === 'false') ? false : value;

      if (self.columns.length >= (j - 2)) {
        self.sclUtilImporter.set(document, self.columns[j - 2], value);
      }
    }

    if (self.extraColumns && self.extraColumnsValue &&
      self.extraColumns.length > 0 && self.extraColumnsValue.length > 0) {
      for (let k = 0; k < self.extraColumns.length; k++) {
        self.sclUtilImporter.set(document, self.extraColumns[k], self.extraColumnsValue[k]);
      }
    }
    if (self.columns[self.getIndexOfDocumentIdInColumnLabels()] === 'documentId' ||
      self.columns[self.getIndexOfDocumentIdInColumnLabels()] === 'docId') {
      self.sclUtilImporter.set(document, self.columns[self.getIndexOfDocumentIdInColumnLabels()], data.documentId);
      document.documentId = data['colData'+(self.getIndexOfDocumentIdInColumnLabels()+1)]
    }

    self.sclUtilImporter.setComponentScopeData(self);
    // checking documentId of data before insert
    if (document.documentId && document.documentId !== '') {
      // check if documentId exist in db or not
      self.dataService.documentExists(document.documentId).then(
        async (foundDoc) => {
          if (foundDoc) {
            self.dataService.getDocument(document.documentId)
              .then(async function successFunc(docData) {
                  // console.log(docData);
                  if (docData) {
                    const originalDoc = cloneDeep(docData);
                    // console.log('originalDoc', originalDoc);
                    document = await self.sclUtilImporter.processDocumentIdMatch(document, docData, self.docIdMatch);
                    // console.log('document', document);
                    const actionName = self.docIdMatch === 'merge' ?
                      'Updated' : 'Replaced';
                    self.dataService.deepDiffUpdate(originalDoc, document)
                      // tslint:disable-next-line:no-shadowed-variable
                      .then(async (data) => {
                          // console.log('data', data);
                          await self.sclUtilImporter.insertSuccess(data, csvIndex, actionName);
                          },
                        async (err) => {
                          await self.sclUtilImporter.insertFail(err, csvIndex, actionName);
                        });

                  }
                },
                async function errorFunc(err) {
                  setTimeout(async () => {
                    await self.sclUtilImporter.processInsertDocIdNoMatch(document, csvIndex, self.docIdNoMatch);
                  });
                });
          } else {
            setTimeout(async () => {
              await self.sclUtilImporter.processInsertDocIdNoMatch(document, csvIndex, self.docIdNoMatch);
            });
          }
        }, async () => {
          setTimeout(async () => {
            await self.sclUtilImporter.processInsertDocIdNoMatch(document, csvIndex, self.docIdNoMatch);
          });
          self.notificationService.error('Document with documentId: ' + document.documentId + ' is not found!');
        });

    } else {
      setTimeout(async () => {
        await self.sclUtilImporter.processInsertDocIdNoMatch(document, csvIndex, self.docIdNoMatch);
      });
    }
    self.imported++;

  }
  eventReloadTable() {
    this.loadItemsToDataTable(this.itemsMatTableData);
  }

  loadItemsToDataTable(items) {
    if (this.isHasTargetTableComponent) {
      const holderObjectDataSet = [];
      const self = this;
      if (items && items !== 0) {
        $.each(items, (key, colValue) => {
          logger.info(key, colValue);
          const objectHolderVariable = {
            ['result']: colValue.colData0,
            [self.componentDefinition.columns[self.getIndexOfDocumentIdInColumnLabels()]]: colValue.documentId
          };
          let colDataCount = 1;
          $.each(self.componentDefinition.columns, (columnKey, columnVal) => {
            // console.log(columnKey, columnVal);
            // @ts-ignore
            if (columnKey >= 0) {
              // @ts-ignore
              objectHolderVariable[columnVal.split('.').slice(-1)[0]] = colValue['colData' + colDataCount];
              colDataCount++;
            }

          });
          holderObjectDataSet.push(objectHolderVariable);
          // holderObjectDataSet.push({
          //   ['result']: colValue.result,
          //   [self.componentDefinition.columns[0].split('.').slice(-1)[0]]: colValue.documentId,
          //   [self.componentDefinition.columns[1].split('.').slice(-1)[0]]: colValue.colData1,
          //   [self.componentDefinition.columns[2].split('.').slice(-1)[0]]: colValue.colData2,
          //   [self.componentDefinition.columns[3].split('.').slice(-1)[0]]: colValue.colData3,
          //   [self.componentDefinition.columns[4].split('.').slice(-1)[0]]: colValue.colData4,
          //   [self.componentDefinition.columns[5].split('.').slice(-1)[0]]: colValue.colData5,
          //   [self.componentDefinition.columns[6].split('.').slice(-1)[0]]: colValue.colData6
          // });


        });
      }

      this.utilSharingNgService.fnPassedDataObject(this.componentDefinition.targetTable,
        'DataListObject_' + this.componentDefinition.targetTable, holderObjectDataSet);
      this.broadcastService.broadcast('DataListObject_' + this.componentDefinition.targetTable
        , {
          fieldName: this.componentDefinition.targetTable,
          objectDataValue: holderObjectDataSet,
          time: new Date().getTime()
        });
      logger.info('test log', this.componentDefinition.targetTable,
        this.utilSharingNgService.fnGetDataObject(this.componentDefinition.targetTable,
          'DataListObject_' + this.componentDefinition.targetTable));

    } else {
      setTimeout(() => {
        this.dataSource.data = this.itemsMatTableData;
        this.dataSource.paginator = this.paginator;
        this.dataSource._updateChangeSubscription();
      });
    }
  }

  resetImport() {
    if (this.disabled) {
      return;
    }
    // this.items.splice(0, this.items.length);
    // this.itemsMatTableData.splice(0, this.itemsMatTableData.length);
    this.items = [];
    this.itemsMatTableData = [];
    this.recordsRead = this.items.length;
    this.documentCreated = 0;
    this.errors = 0;
    this.tempDocId = null;
    // this.dataSource = new MatTableDataSource(this.items);
    this.loadItemsToDataTable(this.itemsMatTableData);

    this.valueChanged(this.items)

    this.detectChanges();
  }

  onFileSelect(files) {

    const reader = new FileReader();
    reader.onload = (e) => {
      let contents = e.target.result.toString();

      try {
        const newLineIdx = contents.lastIndexOf('\n');
        let isLastChar = true;
        if (newLineIdx < contents.length) {
          for (let i = newLineIdx + 1; i < contents.length; i++) {
            if (contents[i] !== '') {
              isLastChar = false;
              break;
            }
          }
        }
        if (newLineIdx !== -1 && isLastChar) {
          contents = contents.substring(0, newLineIdx);
        }
        // console.log(contents);
        let csvArrayValue = null;
        const isFromJsonFile = files[0].name.toLowerCase().split('.json').length > 1;
        const isFromCsvFile = files[0].name.toLowerCase().split('.csv').length > 1;
        if (isFromCsvFile) {
          contents = contents.split('\r').join('\n');
          const csvArray = this.csvJSON(contents);
          // console.log(csvArray);
          // need to verify each line then remove non-unicode character
          // tslint:disable-next-line:prefer-for-of
          for (let i = 0; i < csvArray.length; i++) {
            for (let j = 0; j < csvArray[i].length; j++) {
              if (csvArray[i][j].length > 0) {
                csvArray[i][j] = csvArray[i][j].replace('\r', '').replace('\n', '').replace(/^"(.*)"$/, '$1');
              }
            }
          }
          // console.log(csvArray, csvArray.length);
          csvArrayValue = csvArray;

          const hasHeader = this.validateColumnHeader(csvArrayValue, this.labels);
          let startRow = 0;
          if (hasHeader) {
            startRow = 1;
          }
          const itemsHolderCsv = [];
          const itemsMatTableDataHolderCsv = [];
          for (let k = startRow; k < csvArray.length; k++) {
            // const row = csvArray[k];
            const row = Object.values(csvArray[k]);
            // console.log(k, row, row.length, this.isRowDataObj(row));
            if ((row.length > 0) && this.isRowDataObj(row)) {
              const object = {colData0: 'Awaiting Save', documentId: ''};
              const csvPrefix = this.componentDefinition.csvFieldNamePrefix ? this.componentDefinition.csvFieldNamePrefix : '';
              const objectData = {documentId: ''};
              objectData[csvPrefix + '0'] = 'Awaiting Save';
              let cntCsv = 1;
              for (let l = 0; l < row.length; l++, cntCsv++) {
                objectData[csvPrefix + (cntCsv)] = row[l].toString().trim().replace('\r', '').replace('\n', '').replace(/^"(.*)"$/, '$1');
                object['colData' + (cntCsv)] = row[l].toString().trim().replace('\r', '').replace('\n', '').replace(/^"(.*)"$/, '$1');
              }
              if (this.documentIdIndexInColumn !== null) {
                const getIndexOfDocument = (this.getIndexOfDocumentIdInColumnLabels() + 1);
                const rowValue = row[getIndexOfDocument - 1].toString().trim()
                  .replace('\r', '').replace('\n', '').replace(/^"(.*)"$/, '$1');
                objectData[csvPrefix + getIndexOfDocument] = rowValue;
                object['colData' + getIndexOfDocument] = rowValue;
                object.documentId = rowValue;
                objectData.documentId = rowValue;
              } else {
                object.documentId = '';
                objectData.documentId = '';
              }
              // console.log(object, objectData);
              itemsHolderCsv.push(objectData);
              itemsMatTableDataHolderCsv.push(object);

            }
          }
          this.items = this.items.concat(itemsHolderCsv)
          this.itemsMatTableData = this.itemsMatTableData.concat(itemsMatTableDataHolderCsv)
          // console.log(this.items, this.itemsMatTableData);
          this.recordsRead = this.items.length;
          this.valueChanged(this.items);
          this.detectChanges();
          // this.dataSource = new MatTableDataSource(this.items);
          this.loadItemsToDataTable(this.itemsMatTableData);
          // console.log(this.items, this.document[this.fieldName]);

          if (this.componentDefinition.directImporting) {
            this.saveImports();
          }
        }
        if (isFromJsonFile) {
          const csvArray = JSON.parse(contents);
          // console.log(csvArray);
          csvArrayValue = JSON.parse(JSON.stringify(csvArray));

          const hasHeader = this.validateColumnHeader(csvArrayValue, this.labels);

          let startRow = 0;
          if (hasHeader) {
            startRow = 1;
          }
          // JSON
          const itemsHolderJson = [];
          const itemsMatTableDataHolderJson = [];
          for (const key in csvArray) {
            if (csvArray[key]) {
              const rowTemp = csvArray[key];
              let rowObjectHolder = {} as any;
              try {
                // Reorder row properties on compDef columns setting
                $.each(this.componentDefinition.columns, (colKey, colVal) => {
                  // @ts-ignore
                  if (colKey >= 0) {
                    // @ts-ignore
                    if (rowTemp[colVal.split('.').slice(-1)[0]]) {
                      rowObjectHolder[colVal.split('.').slice(-1)[0]] = rowTemp[colVal.split('.').slice(-1)[0]];
                    } else {
                      rowObjectHolder[colVal.split('.').slice(-1)[0]] = '';
                    }
                  }
                });
              }catch (errReorderRows) {
                console.log(errReorderRows, 'Continue using unordered row');
                rowObjectHolder = rowTemp;
              }
              const row = Object.values(rowObjectHolder);
              if (row.length > 0 && this.isRowDataObj(row)) {
                const csvPrefix = this.componentDefinition.csvFieldNamePrefix ? this.componentDefinition.csvFieldNamePrefix : '';
                const object = {colData0: 'Awaiting Save', documentId: ''};
                const objectData = {documentId: ''};
                objectData[csvPrefix + '0'] = 'Awaiting Save';
                let cntJson = 1;
                for (let j = 0; j< row.length; j++, cntJson++) {
                  objectData[csvPrefix + cntJson] = row[j];
                  object['colData' + cntJson] = row[j];
                }

                if (this.documentIdIndexInColumn !== null) {
                  const getIndexOfDocument = (this.getIndexOfDocumentIdInColumnLabels() + 1);
                  const rowValue = row[getIndexOfDocument - 1] as any as string;
                  objectData[csvPrefix + getIndexOfDocument] = rowValue;
                  object['colData' + getIndexOfDocument] = rowValue;
                  object.documentId = rowValue;
                  objectData.documentId = rowValue;
                } else {
                  object.documentId = '';
                  objectData.documentId = '';
                }
                // console.log(object, objectData);
                itemsHolderJson.push(objectData);
                itemsMatTableDataHolderJson.push(object);

              }
            }

          }
          this.items = this.items.concat(itemsHolderJson)
          this.itemsMatTableData = this.itemsMatTableData.concat(itemsMatTableDataHolderJson)

          this.recordsRead = this.items.length;
          this.valueChanged(this.items);
          this.detectChanges();
          // this.dataSource = new MatTableDataSource(this.items);
          this.loadItemsToDataTable(this.itemsMatTableData);
          // console.log(this.items, this.document[this.fieldName]);
          if (this.componentDefinition.directImporting) {
            this.saveImports();
          }
        }

      } catch (err) {
        console.log(err);
        // var msg = err.message;
        // var pos = msg.match(/position (\d+)/i);
        // var line = 1;
        // if (pos) {
        //   for (var i = 0; i < parseInt(pos[1]); i++) {
        //     if (contents[i] == "\n") {
        //       line++;
        //     }
        //   }
        // }
        //
        // var err_str = "";
        // for (var i = 0; i <= 30; i++) {
        //   err_str += contents[parseInt(pos[1]) + i];
        // }
        // NotificationService.error(err.message + '\n<br /> at line ' + line + " '..." + err_str + "'");
      }

    };

    if (files !== null) {
      reader.readAsText(files[0]);
      this.files = [];
    }
  }

  isRowDataObj(rowData) {
    let hasData = false;
    if (rowData) {
      for (const key in rowData) {
        if (rowData[key].toString().trim() !== '') {
          hasData = true;
          break;
        }
      }
    }
    return hasData;
  }

  validateColumnHeader(dataObject, columnsLabels) {
    let isHeader = true;
    const dataObjectValues = Object.values(dataObject[0]);
    // console.log(columnsLabels, dataObjectValues, dataObjectValues.length, columnsLabels.length);
    if (dataObject.length > 0 && columnsLabels && dataObjectValues.length === columnsLabels.length) {
      for (let i = 0; i < dataObjectValues.length; i++) {
        // console.log(dataObjectValues[i], dataObjectValues[i].toString().trim().replace(/^"(.*)"$/, '$1'), columnsLabels[i]);
        if (dataObjectValues[i].toString().trim().replace(/^"(.*)"$/, '$1') !== columnsLabels[i]) {
          isHeader = false;
          break;
        }
      }
    } else {
      isHeader = false;
    }
    return isHeader;
  }

  csvJSON(stringCsv) {
    // const quoteChar = '"';
    // const delimiter = ',';
    // const regex = new RegExp(`\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`, 'gs');
    // // tslint:disable-next-line:no-shadowed-variable
    // const match = stringCsv => [...stringCsv.matchAll(regex)].map(match => match[2])
    //   .filter((_, i, a) => i < a.length - 1); // cut off blank match at end

    // const linesOld = stringCsv.split('\n');
    const lines: any = Papa.parse(stringCsv).data;
    // console.log(linesOld,lines);
    let retVal = lines.map(line => (line).reduce((acc, cur, i) => ({
      ...acc,
      [`csvCol_${i}`]: (cur.length > 0) ? (Number(cur) || cur.replace(/\n/g, '')) : ''
    }), {}));
    // console.log('beforeFilter',retVal);
    retVal = retVal.filter((el) => {
      return this.isRowDataObj(el);
    });
    // console.log('afterFilter',retVal);
    return retVal;
  }

  sleepFor(sleepDuration) {
    const now = new Date().getTime();
    while (new Date().getTime() < now + sleepDuration) {
    }
  }

  ngOnInit() {
    this.componentSetupService.setupStandardProperties(this);

    if (!(typeof this.componentDefinition.targetTable === 'undefined' || this.componentDefinition.targetTable === null)) {
      for (const comp of this.template.components) {
        if (comp.name === this.componentDefinition.targetTable) {
          this.isHasTargetTableComponent = true;
        }
      }
    }

    this.templateId = this.componentDefinition.templateId;
    // this.componentDefinition = this.template.components[this.key];

    if (typeof this.componentDefinition.documentIdMatch === 'undefined' || this.componentDefinition.documentIdMatch === null) {
      this.docIdMatch = 'merge';
    } else {
      this.docIdMatch = this.componentDefinition.documentIdMatch;
    }

    if (typeof this.componentDefinition.documentIdNoMatch === 'undefined' || this.componentDefinition.documentIdNoMatch === null) {
      this.docIdNoMatch = 'add';
    } else {
      this.docIdNoMatch = this.componentDefinition.documentIdNoMatch;
    }

    if (typeof this.componentDefinition.dataServiceBatchCount === 'undefined' || this.componentDefinition.dataServiceBatchCount === null) {
      this.dataServiceBatchCount = 10;
    } else {
      this.dataServiceBatchCount = this.componentDefinition.dataServiceBatchCount;
    }
    if (typeof this.componentDefinition.dataServiceBatchDelay === 'undefined' || this.componentDefinition.dataServiceBatchDelay === null) {
      this.dataServiceBatchDelay = 250;
    } else {
      this.dataServiceBatchDelay = this.componentDefinition.dataServiceBatchDelay;
    }

    this.columns = this.componentDefinition.columns;
    this.extraColumns = this.componentDefinition.extraColumns;
    this.extraColumnsValue = this.componentDefinition.extraColumnsValue;

    this.labels = this.componentDefinition.labels;
    if (!this.labels) {
      this.labels = this.columns;
    }
    this.labelsForNoTargetTable = ['Result'].concat(this.labels);
    if (this.document[this.fieldName]) {
      const csvPrefix = this.componentDefinition.csvFieldNamePrefix ? this.componentDefinition.csvFieldNamePrefix : '';
      const importFileArrayVal = this.document[this.fieldName];

      const tempArrContainer = [];
      // tslint:disable-next-line:forin
      for (const keyImportArrVal in importFileArrayVal) {
        if (importFileArrayVal[keyImportArrVal]) {
          const importVal = importFileArrayVal[keyImportArrVal];
          const tempArrContainerVal = {documentId: importVal.documentId};
          let incrementVal = 0;
          for (const keyInsideImportVal in importVal) {
            if (keyInsideImportVal.split(csvPrefix).join('') !== 'documentId') {
              tempArrContainerVal['colData' + keyInsideImportVal.split(csvPrefix).join('')] = importVal[keyInsideImportVal];
              incrementVal++;
            }

          }
          tempArrContainer.push(tempArrContainerVal);
        }
      }
      // console.log(importFileArrayVal, tempArrContainer);
      this.items = importFileArrayVal;
      this.itemsMatTableData = tempArrContainer;
      // console.log(importFileArrayVal, this.items);
    }
    this.recordsRead = this.items.length;
    this.documentCreated = 0;
    this.errors = 0;
    this.disableSaving = this.componentDefinition.disableSaving;
    this.incompleteSaving = false;

    this.dataSource.paginator = this.paginator;
    if (this.labelsForNoTargetTable) {
      const displayCol = ['documentId'];
      let incrementVal = 0;
      for (const labelKey in this.labelsForNoTargetTable) {
        if (this.labelsForNoTargetTable[labelKey]) {
          if (incrementVal >= 0) {
            displayCol.push('colData' + incrementVal);
          }
          incrementVal++;
        }
      }
      // console.log(this.labels, displayCol);
      this.displayedColumns = displayCol;
      if (!this.isHasTargetTableComponent) {
        this.loadItemsToDataTable(this.itemsMatTableData);
      }
    }
    // watched function for DataItems
    const self = this;
    const watchDataItems = new Observable(observer => {
      observer.next(this.itemsMatTableData);
      observer.complete();
    });
    watchDataItems.subscribe({
      next: change => {
        const newValue = (change as any);
        if (newValue) {
          if (newValue.objectDataValue) {
            setTimeout(() => {
              console.log('watchDataItems', newValue);
            }, 100);
          }
        }
      }
    });
    // Register Functions To Be Called In Public
    this.functionListToBeCalledInPublic = [
      {
        name: 'eventReloadTable',
        fn: this.eventReloadTable.bind(this)
      }];
    this.utilSharingNgService.fnRegisterFunctions(this.functionListToBeCalledInPublic, this.fieldName, this.document.documentId);

    this.setupChangeDetection();

    this.documentIdIndexInColumn = null;
    for (let i = 0; i < this.columns.length; i++) {
      if ((this.columns[i].split('.').slice(-1)[0] === 'documentId') || (this.columns[i].split('.').slice(-1)[0] === 'docId')) {
        this.setIndexOfDocumentIdInColumnLabels(i);
      }
    }
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnDestroy() {
    super.ngOnDestroy();
    this.resetImport();
  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }

  onFieldValueChanged(fieldValue) {
    if (!fieldValue) {
      fieldValue = [];
    }

    const csvPrefix = this.componentDefinition.csvFieldNamePrefix ? this.componentDefinition.csvFieldNamePrefix : '';
    const importFileArrayVal = fieldValue;
    const tempArrContainer = [];
    // tslint:disable-next-line:forin
    for (const keyImportArrVal in importFileArrayVal) {
      if (importFileArrayVal[keyImportArrVal]) {
        const importVal = importFileArrayVal[keyImportArrVal];
        const tempArrContainerVal = { documentId: importVal.documentId };
        let incrementVal = 0;
        for (const keyInsideImportVal in importVal) {
          if (keyInsideImportVal.split(csvPrefix).join('') !== 'documentId') {
            tempArrContainerVal['colData' + keyInsideImportVal.split(csvPrefix).join('')] = importVal[keyInsideImportVal];
            incrementVal++;
          }
        }
        tempArrContainer.push(tempArrContainerVal);
      }
    }
    this.items = importFileArrayVal;
    this.itemsMatTableData = tempArrContainer;
    this.dataSource.data = this.itemsMatTableData;
    this.dataSource.paginator = this.paginator;
    this.dataSource._updateChangeSubscription();

    this.detectChanges();
  }

  setIndexOfDocumentIdInColumnLabels(index) {
    this.documentIdIndexInColumn = index;
  }

  getIndexOfDocumentIdInColumnLabels() {
    return this.documentIdIndexInColumn;
  }

}
